<template>
  <button class="kloud-launch-button btn btn-primary"
    title="Open this material in the learning environment to review it and write code directly in the browser." @click="$emit('open')">
    <i class="fas fa-cloud" aria-hidden="true"></i> Open Learning Environment
  </button>
</template>
